// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3Nz1k","colCheckbox":"styles_colCheckbox__FvQtX"};